import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Customer, Device, DeviceClassName, NodeEdgeMapper } from '@iotv/datamodel-core';
import { AdjacentType, ComparisonType, isNonNaNNumber, LogicalOperatorType } from '@iotv/iotv-v3-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Chip, Stack, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import { getItemsByType, queryByGraph } from '../../../../data/Wideawake/wideawakeDataFns';
import { CustomerDataGrid } from './CustomerDataGrid';
import { DevicesDataGrid } from './DevicesDataGrid';
const debug = process.env.REACT_APP_DEBUG && false;
export const CustomerDevices = () => {
    const [customers, setCustomers] = useState([]);
    const [nodeEdgeMapper, setNodeEdgeMapper] = useState(new NodeEdgeMapper());
    const [queryTime, setQueryTime] = useState(undefined);
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const [loadingCustomers, setLoadingCustomers] = useState(false);
    const [loadingDevices, setLoadingDevices] = useState(false);
    const getCustomers = async () => {
        setLoadingCustomers(true);
        const res = await getItemsByType('Customer');
        debug && console.log('getCustomers', res);
        if (res.data) {
            setCustomers(res.data.Items.map((vob) => new Customer(vob)));
            setQueryTime(res.data.durationMs);
        }
        setLoadingCustomers(false);
    };
    useEffect(() => {
        getCustomers();
    }, []);
    const getDevices = async (customer) => {
        setLoadingDevices(true);
        const res = await queryByGraph({
            Items: [customer],
            queryPath: [
                {
                    adjacencyType: AdjacentType.CHILD,
                    objectTypeId: 'Group',
                    nodeFilters: [
                        { setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: DeviceClassName }] },
                    ],
                },
                {
                    adjacencyType: AdjacentType.CHILD,
                    objectTypeId: 'Device',
                },
            ],
        });
        debug && console.log('getDevices', res.data);
        if (res.data) {
            setNodeEdgeMapper(new NodeEdgeMapper(res.data.nodeEdgeMapper));
            setQueryTime(res.data.durationMs);
        }
        setLoadingDevices(false);
    };
    const setSelectedCustomerWrapper = (customer) => {
        setSelectedCustomer(customer);
        if (!customer) {
            setNodeEdgeMapper(new NodeEdgeMapper());
            return;
        }
        getDevices(customer);
    };
    const extractCustomerDevices = (customer) => nodeEdgeMapper.getNodesOfType(DeviceClassName).map((vob) => new Device(vob));
    return (_jsxs(Stack, { gap: 1, children: [_jsxs(Stack, { direction: "row", alignItems: "center", gap: 0.5, children: [_jsx(Chip, { label: _jsxs(Typography, { variant: "body2", children: ["Customers: ", customers.length] }) }, "customers"), isNonNaNNumber(queryTime) && _jsx(Chip, { label: _jsxs(Typography, { variant: "body2", children: ["Query time: ", queryTime, " ms"] }) }, "query_time"), selectedCustomer && (_jsx(IconButton, { color: "primary", onClick: () => getDevices(selectedCustomer), sx: { padding: 0.5 }, children: _jsx(RefreshIcon, {}) }))] }), _jsxs(Stack, { direction: "row", gap: 0.5, children: [_jsx(CustomerDataGrid, { loading: loadingCustomers, customers: customers, setSelectedCustomer: setSelectedCustomerWrapper }), selectedCustomer && _jsx(DevicesDataGrid, { loading: loadingDevices, devices: extractCustomerDevices(selectedCustomer) })] })] }));
};
